export enum AsyncJobStatus {
  PROCESS = 0,   // в работе
  SUCCESS = 1,   // выполнено
  CANCELLED = 2, // отменено
  ERROR = 3,     // ошибка
}
